import {OtsUIState} from "../../ots-ui-store";

export const selectUIServiceEventSearchFilter = (state: OtsUIState) => state.uiServiceEvent.searchFilter
